// api.js

import axios from '@/store/interceptor';

import apiUrl from '../../config/api.config'

export async function getRequests() {
    try {
        const response = await axios.get(`${apiUrl}/requests`);
        return response.data;
    } catch (error) {
        console.error("Error fetching requests:", error);
        throw error;
    }
}
export async function getDepartments() {
    try {
        const response = await axios.get(`${apiUrl}/departments`);
        return response.data;
    } catch (error) {
        console.error("Error fetching departments:", error);
        throw error;
    }
}
export async function getAllRequestsTableData() {
    try {
        const response = await axios.get(`${apiUrl}/requests/requests-table-data`);
        return response.data;
    } catch (error) {
        console.error("Error fetching requests:", error);
        throw error;
    }
}

export async function getResponsiblePersonData(equipmentId) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${equipmentId}/responsible-person`);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch responsible person data:", error);
        throw error;
    }
}

export async function getRequestsTableDataByUser(personId) {
    try {
        const response = await axios.get(`${apiUrl}/requests/${personId}/user-requests-table-data`);
        return response.data;
    } catch (error) {
        console.error("Error fetching requests:", error);
        throw error;
    }
}

export async function getUserById(personId) {
    try {
        const response = await axios.get(`${apiUrl}/users/${personId}/`);
        return response.data;
    } catch (error) {
        console.error("Error fetching requests:", error);
        throw error;
    }
}

export async function getEquipmentById(equipmentId) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${equipmentId}/`);
        return response.data;
    } catch (error) {
        console.error("Error fetching requests:", error);
        throw error;
    }
}


export async function getMicroserviceDepartments() {
    try {
        const response = await axios.get(`${apiUrl}/departments/microservice-departments`);
        return response.data;
    } catch (error) {
        console.error("Error fetching departments:", error);
        throw error;
    }
}

export async function fetchEquipmentTypes() {
    try {
        const response = await axios.get(`${apiUrl}/equipment-types`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipment-types:", error);
        throw error;
    }
}
export async function fetchRequestTypes() {
    try {
        const response = await axios.get(`${apiUrl}/request-types`);
        return response.data;
    } catch (error) {
        console.error("Error fetching equipment-types:", error);
        throw error;
    }
}

// department: which of the user's departments the request is for (the main one when omitted)
export async function getEquipmentModels(userId, selectedEquipment, department) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${userId}/equipment-model`, {
            params: {
                equipmentTypeId: selectedEquipment,
                department: department || undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching getEquipmentModels:", error);
        throw error;
    }
}

export async function getEquipmentRegistrationNum(userId, selectedEquipment, selectedModel, department) {
    try {
        const response = await axios.get(`${apiUrl}/equipments/${userId}/equipment-registration-number`, {
            params: {
                equipmentTypeId: selectedEquipment,
                model: selectedModel,
                department: department || undefined,
            }
        });
        // seria, QR code and placement tell apart items of one model in one room (nr. inventar is optional)
        return (response.data || []).map(item => ({
            id: item.id,
            registration_number: item.registration_number,
            responsible_person_id: item.responsible_person_id,
            departmentName: item.departmentName,
            locationInfo: item.locationInfo,
            serial_number: item.serial_number || null,
            tag: item.tag || null,
            location_details: item.location_details || null,
        }));
    } catch (error) {
        console.error("Error fetching getEquipmentRegistrationNum:", error);
        throw error;
    }
}

export async function saveRequestData(postData) {
    try {
        const response = await axios.post(`${apiUrl}/requests`, postData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error saving request:", error);
        throw error;
    }
}

export async function saveResponseData(postData) {
    try {
        const response = await axios.post(`${apiUrl}/responses`, postData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error saving request:", error);
        throw error;
    }
}

export async function updateRequests(requestData) {
    try {
        const response = await axios.patch(`${apiUrl}/requests/${requestData.id}`, requestData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating Requests:", error);
        throw error;
    }
}

export async function downloadReport(params) {
    try {
        const response = await axios.get(`${apiUrl}/requests/report`, {
            params: params,
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        console.error("Failed to download report:", error);
        throw error;
    }
}

export async function getRequestCommentsHistory(requestId) {
    try {
        const response = await axios.get(`${apiUrl}/requests/${requestId}/comments-history`);
        return response.data;
    } catch (error) {
        console.error('Error fetching comments history:', error);
        throw error;
    }
}

export async function getBulkRequestCommentsHistory(requestIds) {
    try {
        const response = await axios.post(`${apiUrl}/requests/bulk-comments-history`, { requestIds });
        return response.data;
    } catch (error) {
        console.error('Error fetching bulk comments history:', error);
        throw error;
    }
}

// The server's message (Romanian); class-validator answers with a list
export function errorMessage(error, fallback) {
    const message = error?.response?.data?.message;
    if (Array.isArray(message)) return message.join("; ");
    return message || fallback;
}

export async function fetchLocations() {
    const response = await axios.get(`${apiUrl}/locations`);
    return response.data;
}

// Models already in use for a type (catalog + existing items): only suggestions, the user may type any model
export async function getModelSuggestions(equipmentTypeId) {
    const response = await axios.get(`${apiUrl}/peripherals/suggestions`, { params: { equipmentTypeId } });
    return response.data;
}

// A NEW item (types that allow it): the server creates the item, the request and its first response together
export async function saveNewItemRequest(postData) {
    const response = await axios.post(`${apiUrl}/requests/new-item`, postData);
    return response.data;
}

// The request as filed + `actions` ({correct, editItem, cancel}) the caller may do on it
export async function getRequestDetails(requestId) {
    const response = await axios.get(`${apiUrl}/requests/${requestId}/requests-details`);
    return response.data[0] || null;
}

// The author's one correction after Contabilitate rejected: back to the Șef
export async function correctRequest(requestId, data) {
    const response = await axios.post(`${apiUrl}/requests/${requestId}/correct`, data);
    return response.data;
}

// Admin: requests are never deleted, they are cancelled with a reason
export async function cancelRequest(requestId, reason, fileIds = []) {
    const response = await axios.post(`${apiUrl}/requests/${requestId}/cancel`, { reason, file_ids: fileIds });
    return response.data;
}
